import { IResponse } from "models";

export enum ActionType {
  POST_CONSENT_STATEMENT = "action/POST_CONSENT_STATEMENT",
  POST_CONSENT_STATEMENT_SUCCESS = "action/POST_CONSENT_STATEMENT_SUCCESS",
  POST_CONSENT_STATEMENT_ERROR = "action/POST_CONSENT_STATEMENT_ERROR",
  POST_CONSENT_STATEMENT_RESET = "action/POST_CONSENT_STATEMENT_RESET",
}

export interface Action<T> {
  type: ActionType;
  payload: T;
}

export interface PostConsentStatementPayload {
  term_content: string;
}

export interface IPostConsentStatemenResponse extends IResponse {
  result: any;
}
